<template>
  <div :class="$style.profile">
    <user-thumbnail
      :class="$style.profile__thumbnail"
      :personalityType="personalityType"
    />
    <div>
      <p :class="$style.profile__brief">
        {{ userProfile }}
      </p>
      <p :class="$style.profile__nickname">{{ userNickname }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import UserThumbnail from '@/components/atoms/UserThumbnail.vue'
import { formatUserProfile } from '@/libs/utilities/formatUserProfile'

import type { MatchUser, PersonalityType } from '@/types/app'

export default defineComponent({
  name: 'UserEssentials',
  components: {
    UserThumbnail,
  },
  props: {
    user: {
      type: Object as PropType<MatchUser>,
      required: true,
    },
  },
  computed: {
    personalityType(): Maybe<PersonalityType> {
      return this.user.diagnosisResult?.personality.type
    },
    userProfile(): string {
      return formatUserProfile(this.user)
    },
    userNickname(): string {
      return this.user.nickname || 'ゲスト'
    },
  },
})
</script>

<style lang="scss" module>
.profile {
  display: flex;
  align-items: center;
  gap: 12px;

  &__thumbnail {
    $size: 56px;

    width: $size;
    height: $size;
  }

  &__brief {
    color: $color-text-and-object-medium-emphasis;
    font-size: 12px;
    line-height: 20px;

    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }

  &__nickname {
    color: $color-text-and-object-high-emphasis;
    font-size: 16px;
    font-weight: bold;
    line-height: 28px;

    &:nth-child(n + 2) {
      margin-top: 4px;
    }
  }
}
</style>
